import { Component, Input } from '@angular/core';
import { SalesOrderHeaderCommentService } from '../../../services';

@Component({
  selector: 'app-sales-order-header-comments',
  templateUrl: './sales-order-header-comments.component.html',
  styleUrl: './sales-order-header-comments.component.scss',
})
export class SalesOrderHeaderCommentsComponent {
  @Input() isModal = false;
  @Input() showSave = false;
  @Input() showBack = false;
  @Input() id = '';
  @Input() commentStart = '';
  @Input() oneRecord = false;

  constructor(public salesOrderHeaderCommentService: SalesOrderHeaderCommentService) {}
}
